module.exports = __webpack_public_path__ + "img/expertise3.a698a7d0.png";